import { api } from '../../utils/api';
import axios from 'axios';

const addApiToken = async ({ _id, _type, secret_id, secret_code, config }) => {
  function endpoint(_type) {
    switch (_type) {
      case 'Facebook API':
        return {
          _end: 'AddApikeysandTokenFacebook',
          key1: 'Facebookid',
          key2: 'Facebooktoken',
        };
      case 'Instagram API':
        return {
          _end: 'AddApikeysandTokenInstagram',
          key1: 'Instagramid',
          key2: 'Instagramtoken',
        };
      default:
        return '';
    }
  }

  try {
    let key1 = endpoint(_type).key1;
    let key2 = endpoint(_type).key2;
    const res = await axios.post(
      `${api}/${endpoint(_type)._end}`,
      {
        _id,
        [key1]: secret_id,
        [key2]: secret_code,
      },
      config
    );
    return res;
  } catch (err) {
    return err;
  }
};

const apiTokenService = {
  addApiToken,
};

export default apiTokenService;
